import { createFileRoute } from "@tanstack/react-router";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section, SectionHeader, CTABand } from "@/components/site/Blocks";
import { buildHead } from "@/lib/seo-head";

const steps = [
  { title: "1. Envíe su escenario", desc: "Complete el formulario corto de pre-calificación o programe una llamada. Comparta los datos básicos de la propiedad, su entidad y la estructura deseada." },
  { title: "2. Revisión inicial", desc: "Un oficial de préstamos revisa su escenario y le indica qué programas y prestamistas mayoristas encajan, generalmente el mismo día hábil." },
  { title: "3. Autorización de crédito y documentos", desc: "Autorice el crédito y cargue documentos de entidad, propiedad, reservas y contrato/arrendamientos de forma segura." },
  { title: "4. Cotización y aprobación", desc: "Reciba una cotización formal con tasa, puntos, plazo, reservas y condiciones. El prestamista mayorista emite la aprobación condicional tras la suscripción." },
  { title: "5. Cierre", desc: "Ordenamos título, avalúo y seguro. Usted cierra en la mesa designada y el préstamo se financia." },
];

export const Route = createFileRoute("/es/proceso")({
  head: () =>
    buildHead({
      title: "Proceso de Préstamo DSCR | Simply Approved Mortgages",
      description:
        "Cómo funciona el proceso de préstamo DSCR y con fines comerciales en 5 pasos: escenario, revisión, documentos, cotización y cierre.",
      url: "/es/proceso",
      locale: "es",
      keywords: "proceso préstamo DSCR, pasos préstamo inversionista, cómo obtener préstamo DSCR, proceso cierre préstamo propiedad de inversión",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Proceso", url: "/es/proceso" },
      ],
      service: { name: "Originación de préstamos DSCR y con fines comerciales" },
    }),
  component: Process,
});

function Process() {
  return (
    <SiteShell>
      <PageHero eyebrow="Proceso" title="Cómo se obtiene un préstamo DSCR o para inversionistas." subtitle="Un proceso de 5 pasos diseñado para inversionistas que necesitan claridad y velocidad." />
      <Section>
        <SectionHeader title="Del escenario al cierre" center />
        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {steps.map((s) => (
            <div key={s.title} className="rounded-2xl border border-border bg-card p-6">
              <h3 className="font-display text-lg font-bold text-foreground">{s.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{s.desc}</p>
            </div>
          ))}
        </div>
      </Section>
      <CTABand title="¿Listo para comenzar?" body="Envíenos su escenario y le indicamos el camino más rápido." />
    </SiteShell>
  );
}
